import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      alignItems: "stretch",
    },
  },
  pieWrapper: {
    "& > $chart": {
      padding: "48px 8px",
      background: theme.palette.grey[100],
      [theme.breakpoints.up("md")]: {
        padding: 48,
        marginLeft: 28,
      },
    },
  },
  list: {
    order: 2,
    alignSelf: "center",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      order: "initial",
      flex: "1",
    },
  },
  chart: {
    order: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
    background: theme.palette.grey[100],
    borderRadius: 8,
    [theme.breakpoints.up("md")]: {
      order: "initial",
      padding: "0 0 0 28px",
      background: "transparent",
    },
  },
}));
